const getAutogeneratedResponseInsideRecursiveQuestion = (context, recursiveQuestionId) => {
  return Object.entries(context.responses).filter(([qid, response]) => {
    return response.question.recursive_question_id === recursiveQuestionId && response.autogenerated;
  })
}


export const removeAutogeneratedRecursiveResponses = (context, recursiveQuestionId) => {
  const recursiveQuestionAutogeneratedResponses = getAutogeneratedResponseInsideRecursiveQuestion(context, recursiveQuestionId);
  context.setResponses((prev) => _.omit(prev, recursiveQuestionAutogeneratedResponses.map(([qid]) => qid)));
  if (context.setAutogeneratedResponsesToRemove) {
    context.setAutogeneratedResponsesToRemove(recursiveQuestionAutogeneratedResponses.reduce((acc, [qid, response]) => {
      acc[response.id] = response;
      return acc;
    },{}));
  }
}

